import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResponsiveService } from '@gelato-api-ui/core/responsive/responsive.service';

@Component({
  selector: 'gd-header-whats-new',
  templateUrl: './header-whats-new.component.html',
  styleUrls: ['./header-whats-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderWhatsNewComponent {
  isMobile$ = this.responsiveService.isMobile$;

  constructor(private readonly responsiveService: ResponsiveService) {}
}
